// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgCircleXmark = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.666 8.003a6.667 6.667 0 1 1-6.667-6.667M10.78 5.34l1.981-1.98m1.98-1.98-1.98 1.98m0 0-1.98-1.98m1.98 1.98 1.98 1.98"
    />
  </svg>
);
export const CircleXmarkIcon = forwardRef(SvgCircleXmark);
